import * as yup from 'yup';

import { commonValidationSchema } from '@olo-web/utils/common/validationSchema';

export const validationSchema = yup.object().shape({
  email: commonValidationSchema.email,
  password: commonValidationSchema.password,
});
